import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import {
  HeadingDisplay,
  BaseText,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import {
  RLPPageData,
  RLPStatus,
  updateRLPStatus,
  UpdateRLPStatusValues
} from '@/modules/trade/services/rlp';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

interface Props {
  pageData: RLPPageData;
}
interface Emits {
  (e: 'on-cancellation'): void;
  (e: 'refresh'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Cancellation',
  props: {
    pageData: null
  },
  emits: ["on-cancellation", "refresh"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-cancellation'): void;
  (e: 'refresh'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pageData: RLPPageData;
}





const isLoading = ref(false);

const handleRLPCancellation = async () => {
  if (props.pageData.form.cancellation) return emit('on-cancellation');

  try {
    isLoading.value = true;

    const data = await updateRLPStatus(UpdateRLPStatusValues.disable);

    notify({
      group: 'wrn-notifications',
      text: data.message,
      type:
        data.status === RLPStatus.Inactive
          ? NotificationTypes.success
          : NotificationTypes.info,
      duration: 6000
    });
    emit('refresh');
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível desativar o Warren RLP. Aguarde um momento e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,props, emit, isLoading, handleRLPCancellation, HeadingDisplay, BaseText, ButtonPrimary }
}

})